import { render, staticRenderFns } from "./ProductCapabilities.vue?vue&type=template&id=241e3574&scoped=true"
import script from "./ProductCapabilities.vue?vue&type=script&lang=js"
export * from "./ProductCapabilities.vue?vue&type=script&lang=js"
import style0 from "./ProductCapabilities.vue?vue&type=style&index=0&id=241e3574&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241e3574",
  null
  
)

export default component.exports